<script>
import store from '../store';
import Constants from '../constants';

export default {
  methods: {
    $can(permissionName, id_pass = -1) {
      //method to verify permissions on user
      if (id_pass < 0) {
        return store.getters['auth/permissions'].includes(permissionName);
      } else {
        return (
          store.getters['auth/permissionsOnBeneficiariesNeopass'][id_pass] || []
        ).includes(permissionName);
      }
    },



    $subscribed() {
      let company = store.getters['auth/structure'];
      //console.log(company, company.has_pro_subscription, company.has_ultimate_subscription);
      return company?.has_pro_subscription || company?.has_ultimate_subscription;
    },

    $subscription() {
      if (
        store.getters['auth/subscription'] !== undefined &&
        store.getters['auth/subscription'] !== []
      ) {
        return store.getters['auth/subscription'].quantity > 0;
      } else {
        return false;
      }
    },

    $trial() {
      let days = store.getters['auth/structure']?.days_before_trial_end ?? null;
      return days != null && days > 0;
    },

    $freeParticulier() {
      // Is Particulier if structure is PARTICULIER and not a guest (a guest has same structure than his host)
      return (
        (store.getters['auth/user']?.is_particulier ?? false) &&
        !store.getters['auth/isGuest']
      );
    },

    $hasAtLeastOneGuest() {
      return (
        this.$freeParticulier() &&
        store.getters['auth/user'].has_at_least_one_guest
      );
    },

    $isGuest() {
      return store.getters['auth/isGuest'];
    },
  },
};
</script>
